import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AreaBlacklistDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/area-blacklist-dto';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { AreaBlacklistService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { HistoryViewComponent } from '../../shared/history/history-view/history-view.component';
import { IHistoryView } from '../../shared/history/history.model';
import { AreaBlacklistAddDialogComponent } from './area-blacklist-add-dialog/area-blacklist-add-dialog.component';

@Component({
  selector: 'app-area-blacklist',
  templateUrl: './area-blacklist.component.html',
  styleUrls: ['./area-blacklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AreaBlacklistComponent implements OnInit {
  AreaBlacklist: AreaBlacklistDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = ['areaBlacklistZip', 'areaBlacklistPlaceName', 'actions'];

  unsubscribe$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private service: AreaBlacklistService,
    private auth: AuthService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {}

  get canEdit() {
    return this.auth.isAdministrator;
  }

  ngOnInit(): void {
    this.getData();
  }

  add() {
    let dialogRef = this.dialog.open(AreaBlacklistAddDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
    });
    dialogRef.afterClosed().subscribe((bl) => {
      if (bl) {
        this.getData();
      }
    });
  }

  async getData() {
    this.loader.show();
    await this.service
      .getAllAreaBlacklist({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (result: AreaBlacklistDto[]) => {
          this.AreaBlacklist = result;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  delete(row: AreaBlacklistDto) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Er du sikker?',
        body: 'Er du sikker på at du vil slette?',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.loader.show();
        this.service
          .removeAreaBlacklist({
            caller: EGIS_SERVICE_CALLER,
            id: row.id,
          })
          .pipe(
            finalize(() => {
              this.loader.hide();
            }),
            takeUntil(this.unsubscribe$),
          )
          .subscribe(
            () => {
              this.getData();
            },
            (error) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  historyView: IHistoryView;
  showhistory(row: AreaBlacklistDto) {
    this.historyView = {
      entityId: row.id,
      historyType: AuditHistoryEnum.AreaBlacklist,
      title: `${row.areaBlacklistZip} ${row.areaBlacklistPlaceName}`,
    };
  }
}
